export const REUNION_IATA_CODE = 'RUN'

// Aéroports parisiens (incluant le code ville PAR) — utilisé par la règle R25 (ligne PAR↔DZA)
export const PARIS_IATA_CODES = new Set<string>(['BVA', 'CDG', 'LBG', 'ORY', 'PAR'])

export const METROPOLITAN_FRANCE_IATA_CODES = new Set<string>([
  'AJA',
  'ANE',
  'AVN',
  'BES',
  'BIA',
  'BIQ',
  'BOD',
  'BVA',
  'BVE',
  'BZR',
  'CCF',
  'CDG',
  'CFE',
  'CFR',
  'CHR',
  'CLY',
  'CMF',
  'DCM',
  'DLE',
  'DNR',
  'DOL',
  'EAP',
  'EBU',
  'EGC',
  'ETZ',
  'FNI',
  'FSC',
  'GNB',
  'LBG',
  'LDE',
  'LEH',
  'LIG',
  'LIL',
  'LME',
  'LRH',
  'LRT',
  'LYS',
  'MLH',
  'MPL',
  'MRS',
  'NCE',
  'NTE',
  'ORY',
  'PAR',
  'PGF',
  'PIS',
  'PUF',
  'QJZ',
  'QOP',
  'QXB',
  'QXG',
  'RDZ',
  'RHE',
  'RNS',
  'SNR',
  'SXB',
  'TLN',
  'TLS',
  'TUF',
  'UIP',
  'URO',
  'VAF',
  'XDB',
  'XDT',
  'XHK',
  'XIZ',
  'XOP',
  'XPJ',
  'XRF',
  'XSH',
  'XWG',
  'XYD',
  'XZI',
  'XZN',
  'ZFJ',
  'ZFQ',
  'ZLN',
])
